import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import moment from 'moment';
import {PageEvent} from '@angular/material/paginator';
import {removeEmptyParams} from "../../../../infrastructure/helper/remove-empty-params";
import {IErpOutboundGroupedResponse} from '../interfaces/erp-outbound-panel.interface';
import {ErpOutboundPanelFilterService} from './erp-outbound-panel-filter.service';

/**
 * Fetches ERP outbound responses grouped by ERP sales order. Reuses the same
 * page-level filters as the flat report; pagination is over distinct orders.
 */
@Injectable({
  providedIn: 'root',
})
export class ErpOutboundReportGroupedService {
  private readonly baseUrl = 'dbov2/adx-invoice-erp-responses/grouped-by-order';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(ErpOutboundPanelFilterService);

  getGroups(page?: Partial<PageEvent>): Observable<IErpOutboundGroupedResponse> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      invoiceNumber: filters?.InvoiceNumber ?? '',
      pnr: filters?.PNR ?? '',
      erpMessageId: filters?.ErpMessageId ?? '',
      erpOrderNumber: filters?.ErpOrderNumber ?? '',
      legalEntityId: filters?.LegalEntityId ?? '',
      queueName: filters?.QueueName ?? '',
      responseType: filters?.ResponseType ?? '',
      result: filters?.Result ?? '',
      createdDateFrom: filters?.CreatedDateFrom ? moment(filters.CreatedDateFrom).format('YYYY-MM-DD') : '',
      createdDateTo: filters?.CreatedDateTo ? moment(filters.CreatedDateTo).format('YYYY-MM-DD') : '',
      adxInvoiceId: filters?.AdxInvoiceId ?? '',
      hasSalesOrderNumber: filters?.HasSalesOrderNumber ?? '',
      hasAdxInvoiceId: filters?.HasAdxInvoiceId ?? ''
    };

    removeEmptyParams(params);

    return this.http.get<IErpOutboundGroupedResponse>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
